
import React, { useState } from "react";
import { MenuItem, Menu, Avatar, Divider } from '@mui/material';
import { setFilterGeometry, setIsLocationFilterOnly } from "../redux/slices/filterSlice";
import { useDispatch } from 'react-redux';
import FieldNames from '../defaults/FieldNames.json';
import ColorConstants from "../defaults/ColorConstants";

export default function CreateMenu({actionFuelsTreatmentClicked, actionFuelsActivityClicked, actionPostFireTreatmentClicked, actionPostFireActivityClicked, actionPostFireProjectClicked, anchorEl, open, handleClose, userInfo, cancelPerimeterCreate}) {
  const dispatch = useDispatch();
  const [ createFuelsTreatmentHover, setCreateFuelsTreatmentHover ] = useState(false);
  const [ createFuelsActivityHover, setCreateFuelsActivityHover ] = useState(false);
  const [ createPostFireTreatmentHover, setCreatePostFireTreatmentHover ] = useState(false);
  const [ createPostFireActivityHover, setCreatePostFireActivityHover ] = useState(false);
  const [ createPostFireProjectHover, setCreatePostFireProjectHover ] = useState(false);

  const handlerInfo = {
    'newFuelsTreatment': {
      onClick: actionFuelsTreatmentClicked,
      setHover: setCreateFuelsTreatmentHover
    },
    'newFuelsActivity': {
      onClick: actionFuelsActivityClicked,
      setHover: setCreateFuelsActivityHover
    },
    'newPostFireTreatment': {
      onClick: actionPostFireTreatmentClicked,
      setHover: setCreatePostFireTreatmentHover
    },
    'newPostFireActivity': {
      onClick: actionPostFireActivityClicked,
      setHover: setCreatePostFireActivityHover
    },
    'newPostFireProject': {
      onClick: actionPostFireProjectClicked,
      setHover: setCreatePostFireProjectHover
    }
  }

  const getActionHandler = (key) => {
    if (handlerInfo[key]) {
      // Cancel any existing planned perimeters
      cancelPerimeterCreate();
      dispatch(setIsLocationFilterOnly(false));
      dispatch(setFilterGeometry(null));
      handlerInfo[key].onClick();
      handleClose();
      handlerInfo[key].setHover(false);
    } else {
      handleClose();
      throw new Error(`No handler found for key: ${key}`);
    }
  }

  return (
      <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
              'aria-labelledby': 'basic-button'
          }}>
          {(userInfo && userInfo[FieldNames.userFields.isFuels] === FieldNames.yesNo.yes) &&
            <span>
              <MenuItem id='menu-item-new-fuels-treatment' style={{ margin: 5}}
                onClick={() => getActionHandler('newFuelsTreatment')}
                onMouseEnter={() => {
                  setCreateFuelsTreatmentHover(true);
                }}
                onMouseLeave={() => {
                  setCreateFuelsTreatmentHover(false);
                }}
              >
                <Avatar sx={{ width: 32, height: 32, margin: '0 10px 0 0', padding: 0, backgroundColor: createFuelsTreatmentHover ? ColorConstants.BlueAlien : ColorConstants.AvatarGray }}>T</Avatar> Create New Fuels Treatment
              </MenuItem>
              <Divider variant="middle" />
              <MenuItem id='menu-item-new-fuels-activity' style={{ margin: 5}}
                onClick={() => getActionHandler('newFuelsActivity')}
                onMouseEnter={() => {
                  setCreateFuelsActivityHover(true);
                }}
                onMouseLeave={() => {
                  setCreateFuelsActivityHover(false);
                }}
              >
                <Avatar sx={{ width: 32, height: 32, margin: '0 10px 0 0', padding: 0, backgroundColor: createFuelsActivityHover ? ColorConstants.BlueAlien : ColorConstants.AvatarGray }}>A</Avatar> Create New Fuels Activity
              </MenuItem>
            </span>
          }
          {(userInfo && userInfo[FieldNames.userFields.isFuels] === FieldNames.yesNo.yes && userInfo[FieldNames.userFields.isPostFire] === FieldNames.yesNo.yes) &&
            <Divider variant="middle" />
          }
          {(userInfo && userInfo[FieldNames.userFields.isPostFire] === FieldNames.yesNo.yes) &&
            <span>
              <MenuItem id='menu-item-post-fire-treatment' style={{ margin: 5}}
                onClick={() => getActionHandler('newPostFireTreatment')}
                onMouseEnter={() => {
                  setCreatePostFireTreatmentHover(true);
                }}
                onMouseLeave={() => {
                  setCreatePostFireTreatmentHover(false);
                }}
              >
                <Avatar sx={{ width: 32, height: 32, margin: '0 10px 0 0', padding: 0, backgroundColor: createPostFireTreatmentHover ? ColorConstants.BlueAlien : ColorConstants.AvatarGray }}>T</Avatar> Create New Post Fire Treatment
              </MenuItem>
              <Divider variant="middle" />
              <MenuItem id='menu-item-post-fire-activity' style={{ margin: 5}}
                onClick={() => getActionHandler('newPostFireActivity')}
                onMouseEnter={() => {
                  setCreatePostFireActivityHover(true);
                }}
                onMouseLeave={() => {
                  setCreatePostFireActivityHover(false);
                }}
              >
                <Avatar sx={{ width: 32, height: 32, margin: '0 10px 0 0', padding: 0, backgroundColor: createPostFireActivityHover ? ColorConstants.BlueAlien : ColorConstants.AvatarGray }}>A</Avatar> Create New Post Fire Activity
              </MenuItem>
            </span>
          }
          {(userInfo && userInfo[FieldNames.userFields.isPostFire] === FieldNames.yesNo.yes) &&
            <span>
              <Divider variant="middle" />
              <MenuItem id='menu-item-post-fire-project' style={{ margin: 5}}
                onClick={() => getActionHandler('newPostFireProject')}
                onMouseEnter={() => {
                  setCreatePostFireProjectHover(true);
                }}
                onMouseLeave={() => {
                  setCreatePostFireProjectHover(false);
                }}
              >
                <Avatar sx={{ width: 32, height: 32, margin: '0 10px 0 0', padding: 0, backgroundColor: createPostFireProjectHover ? ColorConstants.BlueAlien : ColorConstants.AvatarGray }}>P</Avatar> Create New Post Fire Project
              </MenuItem>
            </span>
          }
      </Menu>
  )
}